/**
 * Centralized logging utility.
 * ALL log levels are gated behind import.meta.env.DEV to prevent
 * leaking data (application numbers, premiums, PII) in production.
 *
 * In production, replace with a server-side logging service
 * (Sentry, Datadog, etc.) if observability is needed.
 */

/**
 * Logs debug information (development only).
 * Reads import.meta.env.DEV dynamically so tests can toggle the flag.
 * @param {...any} args
 */
export const logDebug = (...args) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

/**
 * Logs informational messages (development only).
 * @param {...any} args
 */
export const logInfo = (...args) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
};

/**
 * Logs error information (development only in console; in production
 * this should be forwarded to an error tracking service).
 * @param {...any} args
 */
export const logError = (...args) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
  // TODO: In production, send to error tracking service
  // e.g. Sentry.captureException(args[0]);
};

/**
 * Logs warning information (development only).
 * @param {...any} args
 */
export const logWarning = (...args) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};
